module.exports = { src: __webpack_public_path__ + "media/tile-3-overlay.09637c25.webp", width: 365, height: 400 };